<template>
    <section class="show-detail-news" v-if="false">
        <div class="border-box-with-title" v-if="showNews.length > 0">
            <h5 class="box-title">In the News</h5>
            <ul>
                <li v-for="item in showNews" :key="item.id">
                    <div>
                        <a target="_blank" :href="item.link">
                            <img
                                :src="item.featured_image_urls.thumbnail"
                                :alt="item.title.rendered"
                            >
                        </a>
                    </div>
                    <div>
                        <time>{{ item.date | date('MMMM D, YYYY') }}</time>
                        <h6>
                            <a target="_blank" :href="item.link" v-html="item.title.rendered"></a>
                        </h6>
                    </div>
                </li>
            </ul>
            <a class="button" target="_blank" :href="category.link">
                More
                <right-carat/>
            </a>
        </div>
    </section>
</template>

<script>
import api from 'src/api';

export default {
    props: ['categoryId'],
    data() {
        return {
            showNews: [],
            category: {},
        };
    },
    created() {
        api.get(`show-news/${this.categoryId}`).then(result => {
            this.showNews = result.data.posts;
            this.category = result.data.category;
        });
    },
};
</script>

